<template>
  <v-container fluid>
    <v-layout class="main-logo">
      <v-flex>
        <logo />
      </v-flex>
    </v-layout>
    <v-container fluid class="overflow-y-auto menu-scroll-container">
      <v-layout class="menu main-menu">
        <v-flex>
          <v-navigation-drawer permanent stateless>
            <v-list>
              <v-list-item
                v-for="item in mainMenuList"
                :key="item.title"
                :alt="item.title"
                :class="item.class"
                :disabled="item.disabled"
                @click="redirect(item.url)"
              >
                <div class="menu-led led-off"></div>

                <v-list-item-icon>
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-flex
                        class="icon28 led-off"
                        :class="item.icon"
                        v-on="on"
                      ></v-flex>
                    </template>
                    <span>{{ item.title }}</span>
                  </v-tooltip>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.title }}
                    <span class="cota-mais" v-if="item.acesse">ACESSE</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="item-btn-sinistro">
                <div class="menu-led led-off"></div>
                <v-flex>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <form :action="`${urlPostSalesForce}`" method="POST">
                        <v-text-field
                          style="display: none"
                          label="SAMLResponse"
                          name="SAMLResponse"
                          id="SAMLResponse"
                          v-model="samlResponseAvisoSinistro"
                          outlined
                        ></v-text-field>
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          type="submit"
                          id="btnLoginAvisoSinistroSF"
                          ><v-icon>check</v-icon>&nbsp;&nbsp;&nbsp;SINISTROS</v-btn
                        >
                      </form>
                    </template>
                    <span>Sinistros</span>
                  </v-tooltip>
                </v-flex>
              </v-list-item>
            </v-list>
          </v-navigation-drawer>
        </v-flex>
      </v-layout>

      <v-layout class="menu admin-menu">
        <v-flex>
          <v-navigation-drawer permanent stateless>
            <v-list>
              <v-list-item
                v-for="item in adminMenuList"
                :key="item.title"
                :alt="item.title"
                :class="item.class"
                :disabled="item.disabled"
                @click="redirect(item.url)"
              >
                <div class="menu-led led-off"></div>

                <v-list-item-icon>
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-flex
                        class="icon28 led-off"
                        :class="item.icon"
                        v-on="on"
                      ></v-flex>
                    </template>
                    <span>{{ item.title }}</span>
                  </v-tooltip>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-navigation-drawer>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import logo from "@/components/portal/layout/Logo";
import Vue from "vue";
import { mapGetters } from "vuex";
import Helpers from "@/utilities/Helpers";

export default {
  mixins: [Helpers],
  components: {
    logo,
  },
  data() {
    return {
      liberadoTemporario: ["2168", "4837", "5395", "5674", "5680", "2970", "3749"],
      mainMenuList: [
        {
          title: "Início",
          icon: "icon-home",
          class: "featured",
          url: "/Home",
          permissao: "HOME",
          code: "home",
          disabled: false,
          acesse: false,
        },
        {
          title: "Painel de negócios",
          icon: "icon-painel",
          class: "",
          url: "/painel",
          permissao: "DASHBOARD",
          code: "painel",
          disabled: false,
          acesse: false,
        },
        {
          title: "Materiais de Venda",
          icon: "icon-produtos",
          class: "",
          url: "/produtos-previsul",
          permissao: "PRODUTOS",
          code: "produtos",
          disabled: false,
          acesse: false,
        },
        {
          title: "Movimentação de Vidas",
          icon: "icon-movimentacao",
          class: "",
          url: "/movimentacao-de-vidas",
          permissao: "MOVIMENTACAO_VIDAS",
          code: "movimentacao-vidas",
          disabled: false,
          acesse: false,
        },
        // TODO: reativar quando o processamento de arquivos for liberado em produção
        // {
        //   title: "Arquivos DFI",
        //   icon: "icon-documentos",
        //   class: "",
        //   url: "/processamento-arquivos-dfi",
        //   permissao: "PROCESSAMENTO_ARQUIVOS_DFI",
        //   code: "processamento-arquivos-dfi",
        //   disabled: false,
        //   acesse: false,
        // },
        // {
        //   title: "Arquivos Prestamista",
        //   icon: "icon-documentos",
        //   class: "",
        //   url: "/processamento-arquivos-prestamista",
        //   permissao: "PROCESSAMENTO_ARQUIVOS_PRESTAMISTA",
        //   code: "processamento-arquivos-prestamista",
        //   disabled: false,
        //   acesse: false,
        // },
        // {
        //   title: "Arquivos SQG",
        //   icon: "icon-documentos",
        //   class: "",
        //   url: "/processamento-arquivos-sqg",
        //   permissao: "PROCESSAMENTO_ARQUIVOS_SQG",
        //   code: "processamento-arquivos-sqg",
        //   disabled: false,
        //   acesse: false,
        // },
        {
          title: "2ª via digital",
          icon: "icon-emissoes",
          class: "",
          url: "/emissoes",
          permissao: "SEGUNDA_VIA",
          code: "segunda-via",
          disabled: false,
          acesse: false,
        },
        {
          title: "Relatório de Clientes",
          icon: "icon-relatorio",
          class: "",
          url: "/relatorio-geral",
          permissao: "RELATORIOS",
          code: "relatorios",
          disabled: false,
          acesse: false,
        },
        // {
        //   title: "Sinistro",
        //   icon: "icon-sinistro",
        //   class: "",
        //   url: "/sinistro",
        //   permissao: "SINISTRO",
        //   code: "sinistro",
        //   disabled: false,
        //   acesse: false,
        // },
        {
          title: "Ajuda",
          icon: "icon-ajuda",
          class: "",
          url: "/ajuda",
          permissao: "AJUDA",
          code: "ajuda",
          disabled: false,
          acesse: false,
        },
        // {
        //   title: "Aviso Sinistro",
        //   icon: "icon-sinistro",
        //   class: "",
        //   url: "/avisoSinistro",
        //   permissao: "aviso-sinistro",
        //   code: "aviso-sinistro",
        //   disabled: false,
        //   acesse: false
        // }
      ],

      sinistros: [],
      noDataText: "Nenhuma informação pesquisada",
      sinistroSemTMA: false,

      subject: "",
      samlResponseAvisoSinistro: "",
      urlPostSalesForce: process.env.VUE_APP_SSO_SALES_FORCE,

      adminMenuList: [
        {
          title: "Informes Fiscais",
          icon: "icon-informes",
          class: "",
          url: "/informes-fiscais",
          permissao: "INFORMES_FISCAIS",
          code: "informes-fiscais",
          disabled: false,
          acesse: false,
        },
        {
          title: "Comissões",
          icon: "icon-comissoes",
          class: "",
          url: "/comissoes",
          permissao: "COMISSOES",
          code: "comissoes",
          disabled: false,
          acesse: false,
        },
        // {
        //   title: "Sou + Previsul 2020",
        //   icon: "icon-campanha",
        //   class: "",
        //   url: "/sou-mais-previsul",
        //   permissao: "HOTSHOP_ONLINE",
        //   code: "sou-mais-previsul-2020",
        //   disabled: false,
        //   acesse: false
        // },

        {
          title: "Sou + Previsul",
          icon: "icon-campanha",
          class: "",
          url: "/sou-mais-previsul",
          permissao: "HOTSHOP_ONLINE",
          code: "sou-mais-previsul-2021",
          disabled: false,
          acesse: false,
        },

        /*         {
          title: "Sou + Previsul",
          icon: "icon-campanha",
          class: "",
          url: "/sou-mais-previsul",
          permissao: "HOTSHOP_ONLINE",
          code: "sou-mais-previsul",
          disabled: true,
          acesse: false
        },     */
        // { title: 'Colaboradores', icon: 'icon-colaboradores', class: '', url: "/colaboradores", permissao: "COLABORADORES", disabled: false },
        {
          title: "Colaboradores",
          icon: "icon-colaboradores",
          class: "",
          url: "/colaboradores",
          permissao: "COLABORADORES",
          code: "colaboradores",
          disabled: false,
          acesse: false,
        },
        {
          title: "Processos Judiciais",
          icon: "icon-processos",
          class: "",
          url: "/processos-judiciais",
          permissao: "PROCESSOS_JUDICIAIS",
          code: "processos-judiciais",
          disabled: false,
          acesse: false,
        },
      ],
    };
  },
  methods: {
    setActiveMenu(value) {
      for (let item in this.mainMenuList) {
        this.mainMenuList[item].class =
          this.mainMenuList[item].url == value ||
          (this.mainMenuList[item].permissao == "HOME" && value == "/")
            ? "featured"
            : "";
      }
      for (let item in this.adminMenuList) {
        this.adminMenuList[item].class =
          this.adminMenuList[item].url == value ? "featured" : "";
      }
    },

    redirect(value) {
      if (value == "/cota-mais") {
        this.redirectCotaMais();
        return;
      }

      window.location.href = value; // redirect
      this.setActiveMenu(value); // set active menu
    },

    redirectCotaMais() {
      let userRoleId = localStorage.getItem("userRoleId");

      if (userRoleId === null || userRoleId === undefined) {
        userRoleId = 0;
      }

      let urlCotaMais = `${this.$httpCotaMais.defaults.baseURL}?userRoleId=${userRoleId}&hash=${this.usuario.hash}&token=${this.usuario.token}`;
      window.open(urlCotaMais, "_blank");
    },

    verificarPermissao() {
      if (this.usuario.permissoes !== undefined) {
        let listaPermissao = [];
        for (let index in this.usuario.permissoes) {
          listaPermissao.push(this.usuario.permissoes[index].claimType);
        }

        for (let item in this.mainMenuList) {
          // Bloqueando menu

          if (listaPermissao.indexOf(this.mainMenuList[item].code) < 0)
            this.mainMenuList[item].disabled = true;
          else this.mainMenuList[item].disabled = false;
        }
        for (let item in this.adminMenuList) {
          // Bloqueando menu
          if (listaPermissao.indexOf(this.adminMenuList[item].code) < 0)
            this.adminMenuList[item].disabled = true;
          else this.adminMenuList[item].disabled = false;
        }
        this.mainMenuList[0].disabled = false;

        for (let item in this.adminMenuList) {
          // Bloqueando menu
          if (this.adminMenuList[item].code == "sou-mais-previsul-2021") {
            this.adminMenuList[item].disabled = false;
          }
        }

        // permissão para acesso "sou+previsul 2020"

        // let _codCorretor = this.usuario.codCorretor;
        // if(_codCorretor != null)
        // {
        //   let url = "Login/configuracao/" + this.usuario.codCorretor;
        //   Vue.prototype.$httpPortal.get(url)
        //   .then(res => {
        //       let configuracao = res.data;
        //       console.log(url);
        //       console.log(configuracao);
        //       if (configuracao.SouMaisPrevisul2020 == true)
        //       {
        //         for(let item in this.adminMenuList){
        //           // Bloqueando menu
        //           if(this.adminMenuList[item].code == 'sou-mais-previsul-2020')
        //           {
        //             this.adminMenuList[item].disabled = false;
        //           }
        //         }
        //       }
        //   })
        //   .catch(error => {
        //       this.showToast("error","Erro!","Há problemas detectados");
        //   });
        // }

        ////permissão para acesso "sou+previsul 2021"

        let _codCorretor = this.usuario.codCorretor;
        if (_codCorretor != null && _codCorretor.length < 5) {
          let url = "Login/configuracao/" + this.usuario.codCorretor;
          Vue.prototype.$httpPortal
            .get(url)
            .then((res) => {
              let configuracao = res.data;
              if (configuracao.SouMaisPrevisul2021 == true) {
                for (let item in this.adminMenuList) {
                  // Bloqueando menu
                  if (this.adminMenuList[item].code == "sou-mais-previsul-2021") {
                    this.adminMenuList[item].disabled = false;
                  }
                }
              }
            })
            .catch((error) => {
              this.showToast("error", "Erro!", "Há problemas detectados");
            });
        }
      }
    },

    getUserInfo() {
      let userRoleId = localStorage.getItem("userRoleId");
      if (
        this.usuario.codCorretor == null ||
        this.usuario.codCorretor == 0 ||
        this.usuario.permissoes == "" ||
        this.usuario.email == null ||
        this.usuario.email.indexOf("@") == -1
      ) {
        this.setActiveMenu(window.location.pathname);
      } else {
        this.setActiveMenu(window.location.pathname);
        this.verificarPermissao();
      }
    },

    sleep(milliseconds) {
      const date = Date.now();
      let currentDate = null;
      do {
        currentDate = Date.now();
      } while (currentDate - date < milliseconds);
    },

    async enviarRequisicao() {
      let request = {
        subject: this.subject,
        tipoPortal: 1,
      };

      let paramsRequestContaContato = {
        tipoPortal: 1, //Aviso Sinistro ou Portal Corretor
        userId: this.usuarioInfo.userId.toString(),
        personId: parseInt(localStorage.getItem("personId")),
      };

      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        const resultCriacaoContaContato = await Vue.prototype.$httpIdentityServerApi.post(
          "person/createUserContactSF",
          paramsRequestContaContato,
          config
        );

        if (resultCriacaoContaContato.status === 200) {
          const resultAvisoSinistro = await Vue.prototype.$httpPortal.post(
            "SAML/getSAMLResponse",
            request
          );

          this.samlResponseAvisoSinistro = resultAvisoSinistro.data.ObjetoRetorno;
          // document.getElementById('btnLoginAvisoSinistroSF').click();
        }
      } catch (ex) {
        console.log(ex);
      }
    },
  },

  computed: {
    ...mapGetters("usuarioModule", { usuario: "getUserInfo", usuarioInfo: "getUsuario" }),
  },

  watch: {
    "usuario.permissoes"() {
      this.verificarPermissao();
    },
  },

  async mounted() {
    await this.verificarPermissao();
    let cnpjCorretor = localStorage.getItem("cpfCnpj");
    let userCpf = localStorage.getItem("userCpf");
    this.subject = cnpjCorretor + "_" + userCpf;
    this.fullLoading = true;
    await this.enviarRequisicao();
    this.fullLoading = false;
  },
};
</script>

<style lang="scss">
.v-navigation-drawer {
  .v-list-item {
    .v-list-item__title {
      text-transform: uppercase;
      font-size: var(--menu-font);
    }
  }
}

.container.grid-list-md .layout .flex {
  padding: 0;
}

.menu .theme--light.v-list .v-list-item--link .v-list-item__content {
  color: var(--white) !important;
}

.menu .theme--light.v-list .v-list-item--link:hover .v-list-item__icon .icon28 {
  background-color: var(--white);
}
.menu .theme--light.v-list .v-list-item--link:hover .menu-led {
  background-color: var(--white);
}
.menu .theme--light.v-list .v-list-item--link:hover {
  background-color: var(--blue-light);
}

.menu .v-list > div:not(:last-child) {
  margin-bottom: 1px;
}
.menu .v-list > div {
  background-color: var(--blue-medium);
}
.menu .v-list .featured {
  background-color: var(--blue-light);
}
.menu .theme--light.v-list .featured .menu-led {
  background-color: var(--white);
}
.menu .v-list .featured .icon28 {
  background-color: var(--white);
}
.menu .v-list .cota-mais {
  background-color: #e79118;
  padding: 7px 15px 5px 15px;
  font-size: 11px;
  display: inline-block;
  margin-left: 50px;
  border-radius: 50px;
}
.menu .v-list .cota-mais .v-list-item--link .menu-led {
  background-color: var(--blue-light);
}
.menu .v-list .cota-mais .icon28 {
  background-color: var(--white);
}

.menu .v-list-item {
  min-height: var(--menu-height);
}

.menu-led {
  width: 10px;
  height: 40px !important;
  flex: none;
}

.led-off {
  background-color: var(--blue-light);
}
.led-on {
  background-color: var(--white);
}
.admin-menu {
  margin-top: var(--menu-height);
}

.menu-scroll-container {
  height: calc(100vh - var(--header-height)) !important;
  overflow-y: auto;
}

#btnLoginAvisoSinistroSF {
  background-color: var(--blue-medium) !important;
  border: none !important;
  color: var(--white) !important;
  margin-left: 2% !important;
  box-shadow: none !important;
  width: 54% !important;
  display: flex;
  justify-content: space-around;
}

div.item-btn-sinistro:hover,
div.item-btn-sinistro:hover #btnLoginAvisoSinistroSF {
  background-color: var(--blue-light) !important;
}

div.item-btn-sinistro:hover .menu-led {
  background-color: var(--white) !important;
}
</style>
